import { Link } from 'react-router-dom'
import React from 'react'
import AppRoutes from '../../services/AppRoutes'
import OrgariseLogoWhite from '../../images/OrgariseLogowhite.png'
import CookiesStorageService from '../../services/CookiesStorageService'

const LogoBtn = () => (
  <Link
    to={`${CookiesStorageService.getUserId() ? `${AppRoutes.home}` : '#'}`}
    style={styles.logoContainer}>
    <img src={OrgariseLogoWhite} alt="logo" style={styles.img} />
  </Link>
)
const styles = {
  logoContainer: {
    textDecoration: 'none',
    fontSize: 'larger',
    color: '#fff',
    fontWeight: 'bolder',
    marginRight: { xs: '10px', sm: '30px' },
  },
  img: { maxWidth: '100px', marginTop: '8px' },

}
export default LogoBtn
